import script from "./FormDate.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDate.vue?vue&type=script&setup=true&lang=js"

import "./FormDate.vue?vue&type=style&index=0&id=1fad0ea3&lang=scss"

const __exports__ = script;

export default __exports__